var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "var(--text-gray-300)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.113 8a2.888 2.888 0 015.774 0 2.888 2.888 0 01-5.774 0zm1 0A1.89 1.89 0 008 9.887 1.89 1.89 0 009.887 8 1.89 1.89 0 008 6.113 1.89 1.89 0 006.113 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10c-.707-1.1-.707-2.893 0-4 1.633-2.547 4-4.013 6.5-4.013S12.867 3.453 14.493 6c.707 1.1.707 2.893 0 4C12.867 12.547 10.5 14.013 8 14.013c-2.507 0-4.873-1.466-6.5-4.013zm.847-3.46c-.5.78-.5 2.14 0 2.92 1.44 2.26 3.5 3.553 5.653 3.553 2.153 0 4.213-1.293 5.653-3.553.5-.78.5-2.14 0-2.92-1.44-2.26-3.5-3.553-5.653-3.553-2.153 0-4.213 1.293-5.653 3.553z"
  }))));
}
export default SvgPostView;